<template>
  <div>
    <div class="field is-grouped">
      <div class="control">
        <button class="button is-link" @click="getModalConfirmation('Lock Event Report', 'Are you sure want to lock this report?', 'action')">Lock Event Report</button>
      </div>
    </div>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th class="has-text-centered" rowspan="3"></th>
        <th class="has-text-centered" colspan="3">Ticket Complimentary</th>
        <th class="has-text-centered" colspan="8">Ticket Penjualan</th>
      </tr>
      <tr>
        <th class="has-text-centered" rowspan="2">Awal</th>
        <th class="has-text-centered" rowspan="2">Diambil</th>
        <th class="has-text-centered" rowspan="2">Sisa</th>
        <th class="has-text-centered" rowspan="2">Awal</th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">Maybank</th>
        <th class="has-text-centered" colspan="2"></th>
        <th class="has-text-centered" rowspan="2">Sisa</th>
      </tr>
      <tr>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Cash</th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tr v-for="(data_row, index) in data_list" :key="index">
        <table-row v-for="(value_row, index_value) in data_row" :key="index_value" :value-row="value_row"></table-row>
      </tr>
    </table>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="executeModalAction"></confirmation-modal>
  </div>
</template>

<script>
import TableRow from '@/pages/panel/frontdesk/components/ReportRowEvent'
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      selected_service: '',
      data_list: []
    }
  },
  components: {
    TableRow
  },
  created () {
    this.selected_service = this.getSessionItem('selected_service_leader')
    this.getReport()
  },
  methods: {
    getReport () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('report/event_tl', {
        service: this.selected_service
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.data_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    executeModalAction (confirmData) {
      if (confirmData.label === 'action') {
        if (confirmData.flag === true) {
          var self = this
          self.$geb.emit({id: 'preloader', eventData: true})
          self.flyGetSession('report/lock_event_tl').then(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            if (response.data.response_code === 1) {
              self.$geb.emit({id: 'alert_modal', title: 'Lock Event Report Success!', content: 'Event Report berhasil di Lock!', button_text: 'OK'})
            } else {
              var result = response.data.message
              self.errors.clear()
              for (var name in response.data.message) {
                self.errors.add(name, result[name])
              }
            }
          }).catch(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            self.errorMessage(response)
          })
        }
      }

      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/report_event/Leader.vue